import { render, staticRenderFns } from "./monetaryAccountModal.vue?vue&type=template&id=5c137785&scoped=true&"
import script from "./monetaryAccountModal.vue?vue&type=script&lang=js&"
export * from "./monetaryAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c137785",
  null
  
)

export default component.exports